import { Box, Button, Grid, TextField } from "@mui/material";
import React from "react";
import { useForm } from "react-hook-form";

export default function MicroscopicTestForm({ defaultValues, onSubmit }) {
  const { register, handleSubmit } = useForm({ defaultValues: defaultValues || {} });

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Pus" size="small" variant="outlined" name="pus" {...register('pus')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="RBCs" size="small" variant="outlined" name="rbcs" {...register('rbcs')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Epithelial Cells" size="small" variant="outlined" name="epiCells" {...register('epiCells')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <TextField label="Ca. Oxalate" size="small" variant="outlined" name="caOxalate" {...register('caOxalate')} InputLabelProps={{ shrink: true }} fullWidth />
        </Grid>
      </Grid>
      <Box mt={2}>
        <Button type="submit" variant="contained" color="primary" size="small">सुरक्षित गर्नुहोस्</Button>
      </Box>
    </form>
  );
}
